'use client';

import { c as _c } from "react/compiler-runtime";
import SvgDelete from '@common/__generated__/icon/SvgDelete';
import { Button, Modal } from '@common/components';
import SvgSuccess from '@common/icon/SvgSuccess';
interface DonationReservationCompleteModalProps {
  opened: boolean;
  onClose?: () => void;
}

/**
 * * 기부 사전예약 임시 모달
 */
export const DonationReservationCompleteModal = t0 => {
  const $ = _c(11);
  const {
    opened,
    onClose
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <SvgSuccess className="size-20 text-G-300" />;
    t2 = <p className="font-700 text-Gray-900 typo-body2">기부 사전 예약 완료</p>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <br />;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="flex flex-col items-center gap-8 px-20 pb-24 pt-32">{t1}{t2}<p className="font-400 text-Gray-700 typo-body3">기부 사전 예약이 완료되었습니다.{t3}기부 오픈 시 발송되는<br />카카오 알림톡을 꼭 확인해주세요!</p></div>;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <SvgDelete className="size-24 text-Gray-900" />;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== onClose) {
    t6 = <Button theme="sub-text" className="absolute right-22 top-18 size-fit p-0" onClick={onClose}>{t5}</Button>;
    $[5] = onClose;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== onClose || $[8] !== opened || $[9] !== t6) {
    t7 = <Modal opened={opened} onClose={onClose} className="relative max-h-[90%] min-w-280 p-0 lg:max-h-[90%] lg:min-w-280 lg:p-0">{t4}{t6}</Modal>;
    $[7] = onClose;
    $[8] = opened;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  return t7;
};